import { Loader } from "@dbn/omnichannel-design-system-g4p";
import { useEffect } from "react";
import { useCommand } from "../useAPI";
import * as api from "./api";
import { pipe } from "fp-ts/function";
import { taskEither } from "fp-ts";
import { RuntimeLocaleKey, useFormatMessage } from "../intl";

type Props = {
  onContinue: () => unknown;
  onError: () => unknown;
  applicantIndex?: string;
};

export function DigitalIdStart({ onContinue, onError, applicantIndex }: Props) {
  const start = useCommand(api.digitalIdStart);
  const formatMessage = useFormatMessage();

  useEffect(() => {
    pipe(
      start({ applicantIndex }),
      taskEither.fold(
        _ => taskEither.fromIO(onError),
        _ => taskEither.fromIO(onContinue)
      )
    )();
  }, []);

  return (
    <>
      <Loader
        ariaLabelMessage={formatMessage(
          "generic.loading.alt" as RuntimeLocaleKey
        )}
      />
    </>
  );
}
